import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseDictionary, ServerDTO, TableColumn } from '../../../../models/app.model';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../store/reducers';
import { RestService } from '../../../../service/rest.service';
import { CarFinanceObject,
  CommonFinanceDocument, LandFinanceObject } from '../../../../models/finance-document.model';
import { FormControl } from '@angular/forms';
import { dtoFormatter, typeCaster } from '../../../../shared/helpers/helper.system';
import { Member, VpDictionary, VpoName } from '../../../../models/vpo.model';
import { forkJoin, Observable, of } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { FinanceObjectLandAdderComponent } from '../../shared/dialogs/finance-object-land-adder/finance-object-land-adder.component';
import swal from 'sweetalert2';
import { AppAlerts } from '../../../../shared/configs/app.alerts';
import { AppMessages } from '../../../../shared/configs/app.messages';
import * as messageActions from '../../../../store/actions/messages';
import { FinanceObjectCarAdderComponent } from '../../shared/dialogs/finance-object-car-adder/finance-object-car-adder.component';
import { FinanceMemberAdderComponent } from '../dialogs/finance-member-adder/finance-member-adder.component';



@Component({
  selector: 'app-income-object-adder',
  templateUrl: './income-object-adder.component.html',
  styleUrls: ['./income-object-adder.component.scss']
})
export class IncomeObjectAdderComponent implements OnInit {

  @Input() idFinanceDocument: string;
  @Input() isParent: boolean = true;
  @Input() parentMemberDocument: CommonFinanceDocument;
  @Output() financeDocument$ = new EventEmitter<CommonFinanceDocument>();
  // @Output() lands$ = new EventEmitter<Array<LandFinanceObject>>();
  // @Output() cars$ = new EventEmitter<Array<CarFinanceObject>>();
  @Output() exit$ = new EventEmitter<boolean>();


  columnsL: Array<TableColumn> = [];
  columnsC: Array<TableColumn> = [];
  columnsM: Array<TableColumn> = [];
  codeId: string;
  objectIsReady = false;
  selected: CommonFinanceDocument;
  subscribers: Array<any> = [];
  isAdd: boolean = false;
  //
  // for vpo select
  vpoControl: FormControl;
  vpoObjects: Array<VpoName> = [];
  // for vp select
  vpControl: FormControl;
  vpObjects: Array<VpoName> = [];
  filteredVp$: Observable<Array<VpDictionary>>;
  // for member select
  memberControl: FormControl;
  memberObjects: Array<Member> = [];
  filteredMembers$: Observable<Array<Member>>;
  // for positions
  positionControl: FormControl;
  positionObjects: Array<BaseDictionary> = [];
  filteredPositions$: Observable<Array<BaseDictionary>>;
  //
  familyMembers: Array<CommonFinanceDocument> = [];
  carObjects: Array<CarFinanceObject> = [];
  landObjects: Array<LandFinanceObject> = [];

  constructor(protected activatedRoute: ActivatedRoute,
              protected route: Router,
              protected store: Store<fromRoot.AppState>,
              protected restService: RestService,
              protected dialog: MatDialog) { }

  ngOnInit() {

    this.isAdd = this.idFinanceDocument ? false : true;

    this.selected = <CommonFinanceDocument>{};
    this.vpoControl = new FormControl();
    this.vpControl = new FormControl();
    this.memberControl = this.isAdd ? new FormControl() : new FormControl({value: '', disabled: true});
    this.positionControl = new FormControl();

    this.columnsM = [
      {
        userName: 'Фамилия И.О.', sysName: 'memberName', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      },
      {
        userName: 'Тип', sysName: 'memberTypeName', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      },
      {
        userName: 'Год', sysName: 'year', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: false, value: ''}
      },
      {
        userName: 'Доход', sysName: 'total', isSort: false, isView: true, type: 'currency',
        filter: {type: 'string', on: false, value: ''}
      },
      {
        userName: 'Показывать', sysName: 'isView', isSort: false, isView: true, type: 'boolean',
        filter: {type: 'boolean', on: false, value: ''},
        colorCondition: {color: '#7a7a7a', condition: 'equal', conditionValue: 0}
      },
    ];

    this.columnsL = [
      {
        userName: 'Наименование', sysName: 'name', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      },
      {
        userName: 'Тип', sysName: 'type', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      },
      {
        userName: 'Адрес', sysName: 'address', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: false, value: ''}
      },
      {
        userName: 'Площадь', sysName: 'landS', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: false, value: ''}
      }
    ];

    this.columnsC = [
      {
        userName: 'Наименование', sysName: 'name', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      },
      {
        userName: 'Тип', sysName: 'type', isSort: false, isView: true, type: 'string',
        filter: {type: 'string', on: true, value: ''}
      }
    ];

    const idMember = this.parentMemberDocument ? this.parentMemberDocument.idMember : null;


    /**
     * Main data
     */
    const incomes$ = !this.isAdd ? this.restService
      .getOneFinanceById(this.idFinanceDocument)
      .pipe(
        tap((data: CommonFinanceDocument) => this.selected = data)
      ) : of([<CommonFinanceDocument>{}]);

    const vpoObjects$ = this.isParent ? this.restService
      .getVpoActive()
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<VpoName>(p)),
        tap((data: any) => this.vpoObjects = data)
      ) : of([]);

    const vpObjects$ = this.isParent ? this.restService
      .getVpDictionariesActiveData()
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<VpDictionary>(p)),
        tap((data: any) => this.vpObjects = data)
      ) : of([]);

    const memberObjects$ = this.restService
      .getMembersDictionariesTotalData(idMember)
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<Member>(p)),
        tap((data: any) => this.memberObjects = data.filter(d => d.disabled === 0))
      );

    const positionObjects$ = this.isParent ? this.restService
      .getBasesDictionariesData('positions')
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<BaseDictionary>(p)),
        tap((data: any) => this.positionObjects = data)
      ) : of([]);

    /**
     * Others data
     */

    const incomesCars$ = !this.isAdd ? this.restService
      .getOneFinanceCarsById(this.idFinanceDocument)
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<CarFinanceObject>(p)),
        tap((data: any) => this.carObjects = data)
      ) : of([]);

    const incomesLands$ = !this.isAdd ? this.restService
      .getOneFinanceLandsById(this.idFinanceDocument)
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<LandFinanceObject>(p)),
        tap((data: any) => this.landObjects = data)
      ) : of([]);

    const objects$ = forkJoin([incomes$, vpoObjects$, vpObjects$,
      memberObjects$, positionObjects$, incomesCars$, incomesLands$]);

    objects$.subscribe(() => {

      this.objectIsReady = true;

      if ( !this.isAdd ) {

        const selectedVpo = this.vpoObjects.filter(f => f.id === this.selected.idVpo)[0];
        const selectedVp = this.vpObjects.filter(f => f.id === this.selected.idVp)[0];
        const selectedMember = this.memberObjects.filter(f => f.id === this.selected.idMember)[0];
        const selectedPosition = this.positionObjects.filter(f => f.id === this.selected.idPosition)[0];

        if (selectedVpo) {
          this.vpoControl.setValue(selectedVpo);
          this.selected.idVpo = selectedVpo.id;
        }

        if (selectedVp) {
          this.vpControl.setValue(selectedVp);
          this.selected.idVp = selectedVp.id;
        }

        if (selectedMember) {
          this.memberControl.setValue(selectedMember);
          this.selected.idMember = selectedMember.id;
        }

        if (selectedPosition) {
          this.positionControl.setValue(selectedPosition);
          this.selected.idPosition = selectedPosition.id;
        }

        this.getFamilyMembers$()
            .subscribe(() => {
              console.log('ok');
        });

      } else {
        this.selected.year = this.isParent ? new Date().getFullYear() - 1 : this.parentMemberDocument.year;
        if ( !this.isParent ) {
          this.selected.idVp = this.parentMemberDocument.idVp;
          this.selected.idVpo = this.parentMemberDocument.idVpo;
          this.selected.sort = this.parentMemberDocument.sort;
          this.selected.isView = this.parentMemberDocument.isView;
        }
      }

    });


    /**
     * Autocomplete
     */

    this.filteredVp$ = this.vpControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.vpObjects))
      );

    this.filteredMembers$ = this.memberControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.memberObjects, 'lname'))
      );

    this.filteredPositions$ = this.positionControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.positionObjects))
      );

  }


  /**
   * For autocomplete selects
   */
  displayFn(s?: any): string | undefined {
    return s ? (s.name || s.title || (s.lname + ' ' + s.fname + ' ' + s.sname)) : undefined;
  }

  selectVpo(event) {
    this.selected.idVpo = typeCaster<VpoName>(event.source.value).id;
  }

  selectVp(event) {
    this.selected.idVp = typeCaster<VpDictionary>(event.source.value).id;
  }

  selectMember(event) {

    const member = typeCaster<Member>(event.source.value)

    this.selected.idMember = member.id;

    if ( !this.isParent ) {
      this.selected.memberName = member.lname + ' ' + member.fname + ' ' + member.sname;
      this.selected.memberTypeName = member.memberTypeName;
      this.selected.idMemberType = member.idType;
    }
  }

  selectPosition(event) {
    this.selected.idPosition = typeCaster<Member>(event.source.value).id;
  }

  protected _filter(value: string, object: Array<any> = [], key: string = 'name') {
    if (typeof value !== 'string' || !value) {
      return;
    }
    const filterValue = value.toLowerCase();
    return object.filter( s => s[key] ? s[key].toLowerCase().includes(filterValue) : s);
  }

  private getFamilyMembers$ = () => {
    return this.isParent ? this.restService
      .getFinanceFamilyMembers(this.selected.idMember, this.selected.year)
      .pipe(
        map( (p: ServerDTO) => dtoFormatter<CommonFinanceDocument>(p)),
        tap((data: any) => this.familyMembers = data)
      ) : of([]);
  }

  /**
   * Dialogs
   */
  openLandAddDialog(data: LandFinanceObject = null) {

    const dialogRef = this.dialog.open(FinanceObjectLandAdderComponent, { width: '50%',
      data: {object: data, id: this.selected.id}});

    dialogRef.afterClosed().subscribe((res: LandFinanceObject) => {

      if ( !res ) {
        return;
      }
      // remove
      if (!this.isAdd) {
        this.landObjects = this.landObjects.filter( d => d.id !== res.id);
      }
      // then add
      this.landObjects.push(res);
    });
  }

  openMemberAddDialog(data: any) {

    if ( !this.idFinanceDocument ) {
      throw new Error('Finance document\'s id is not provided!');
      return;
    }

    if ( !this.selected.idMember ) {
      swal({
        title: AppAlerts.MEMBER_IS_EMPTY,
        type: 'error',
      });
      return;
    }

    const dialogRef = this.dialog.open(FinanceMemberAdderComponent, { width: '70%', data:
        {
          id: data && data.id ? data.id : null,
          parentMemberDocument: this.selected
        }
    });

    dialogRef.afterClosed().subscribe((res: CommonFinanceDocument) => {
      if ( !res ) {
        return;
      }
      // remove
      if (!this.isAdd) {
        this.familyMembers = this.familyMembers.filter( m => m.idMember !== res.idMember);
      }
      // then add
      this.familyMembers.push(res);
    });
  }

  openCarAddDialog(data: CarFinanceObject = null) {

    const dialogRef = this.dialog.open(FinanceObjectCarAdderComponent, { width: '50%',
      data: {object: data, id: this.selected.id}});
    dialogRef.afterClosed().subscribe((res: LandFinanceObject) => {

      if ( !res ) {
        return;
      }
      // remove
      if (!this.isAdd) {
        this.carObjects = this.carObjects.filter( d => d.id !== res.id);
      }
      // then add
      this.carObjects.push(res);
    });
  }

  removeData(id: string, type: string) {

    if (!id || !type) {
      throw new Error('id or type is not defined!');
    }

    const _this = this; // reference

    swal({
      title: AppAlerts.DELETE_OBJECT_TITLE,
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {

      if (action.value === true) {
        if (type === 'land') {
          _this.restService.deleteOneFinanceLand(id)
            .subscribe(res => {
              _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_REMOVE_SUCCESS));
              _this.landObjects = _this.landObjects.filter(d => d.id !== id);
            });
        }
        if (type === 'car') {
          _this.restService.deleteOneFinanceCar(id)
            .subscribe(res => {
              _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_REMOVE_SUCCESS));
              _this.carObjects = _this.carObjects.filter(d => d.id !== id);
            });
        }
      }

    });
  }

  removeMember(id: string) {

    if ( !id ) {
      throw new Error('id is not defined!');
    }

    const _this = this; // reference

    swal({
      title: AppAlerts.DELETE_OBJECT_TITLE,
      text: AppAlerts.FINANCE_OBJECT_DELETE_TEXT,
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {
      if (action.value === true) {
        _this.restService.deleteOneFinanceById(id)
            .subscribe(res => {
              _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_REMOVE_SUCCESS));
              _this.familyMembers = _this.familyMembers.filter(m => m.id !== id);
            });
      }

    });
  }

  emitExit() {
    this.exit$.emit(true);
  }

  redirectToParent() {
    // redirect
    this.route.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  save() {

    const _this = this; // reference

    swal({
      title: AppAlerts.SAVE_OBJECT_TITLE,
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {

      if (action.value === true) {

        // check object (1)
        if ( !Object.keys(_this.selected).length ) {
          swal({
            title: AppAlerts.OBJECT_IS_EMPTY,
            type: 'error',
          });
          return;
        }

        if ( !_this.selected.idVp || !_this.selected.idVpo ||
             !_this.selected.year || !_this.selected.idMember
        ) {
          swal({
            title: AppAlerts.ERROR_REQUIRED_FIELDS,
            type: 'error',
          });
          return;
        }

        const saveData$ = _this.isAdd ?
            _this.restService.addOneFinance(_this.selected) :
            _this.restService.updateOneFinance(_this.idFinanceDocument, _this.selected);

        saveData$
            .subscribe(
              (d: any) => {
                _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.APP_SAVE_SUCCESS));
                if (_this.isAdd) {
                  _this.selected.id = d.insertId;
                }
                if (!_this.isParent) {
                  _this.financeDocument$.emit(_this.selected);
                } else {
                  _this.redirectToParent();
                }
              },
              error => {
                _this.store.dispatch(new messageActions.ErrorMessage(AppMessages.APP_SAVE_ERROR));
              }
            );
      }

    });
  }

}
